import { faHashtag } from '@fortawesome/pro-regular-svg-icons/faHashtag'

import { Emoji } from '@space-lib/components/emoji'
import Avatar from '@space-shell/common/components/avatar'
import Icon from '@space-shell/common/components/icon'

import type { CommunityAvatarProps } from './types'

import { useThemeAvatar } from '../../../baseLayout/hooks/useThemeAvatar'

export const CommunitiesListAvatarItem = ({ community, className }: CommunityAvatarProps) => {
  const { selectAvatar } = useThemeAvatar()

  if (community.icon) {
    return <Emoji id={community.icon} size='1.5rem' />
  }

  if (community.imageURL) {
    return (
      <Avatar
        size='sm'
        className={className}
        type='rounded'
        urlAvatar={selectAvatar(community?.imageURL)}
      />
    )
  }

  return (
    <span
      data-test='empty-icon-sign'
      className='_flex-1 _d-flex _align-items-center _justify-content-center'>
      <Icon icon={faHashtag} className='_text-gray-900' />
    </span>
  )
}
